import { Module } from 'vuex-smart-module';
import OrganizationsSharedActions from './actions';
import OrganizationsSharedGetters from './getters';
import OrganizationsSharedMutations from './mutations';
import OrganizationsSharedState from './state';

export default new Module({
  state: OrganizationsSharedState,
  mutations: OrganizationsSharedMutations,
  actions: OrganizationsSharedActions,
  getters: OrganizationsSharedGetters,
});
